import { axios } from '../../services/axios';

export default async function getSRTRegionsForServiceProfile(scope) {
    const result = await axios.get(
        `/ServiceProfiles/SRT/${scope}/Regions/Available`,
    );
    return result;
}
